<template>
<div class="wl-register-account">
    <div class="top-crumbs-navigation">
        <i class="wl-icon-weizhi"></i> 当前位置：
        <span>网站首页</span>
        <span class="sp-icon">></span>
        <span>用户注册</span>
    </div>
    <div class="register-step-flow">
        <!-- 填写账号信息 -->
        <div class="register-wrapper">
            <div class="register-main">
                <div class="mc-register-main">
                    <div class="mc-register-mask clearfix">
                        <el-form :model="ruleForm" ref="registerForm" :rules="rules" label-width="100px" class="new-register-form-wrappper">
                            
                            <el-form-item label="学校" prop="schoolId">
                                <el-select v-model="ruleForm.schoolId"
                                        clearable
                                        filterable
                                        :filter-method="filterSchool"
                                        placeholder="请选择学校">
                                    <el-option prefix-icon="yk-icon-xuexiao"
                                                v-for="item in schoolList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="账号" prop="userName">
                                <el-input v-model="ruleForm.userName"
                                        class="form_input"
                                        placeholder="请输入账号"
                                        maxlength="50"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="验证码：" class="short-message-form" prop="captcha">
                                    <div class="captcha-phone-input">
                                        <el-input placeholder="请输入短信验证码" v-model="ruleForm.captcha"></el-input>
                                    </div>
                                    <el-button v-if="show1" type="primary" class="captcha-phone-button" @click="sendMessage()">发送验证码</el-button>
                                    <el-button v-if="show2" type="primary" :disabled="true" class="captcha-phone-button">{{count}}s</el-button>
                                    <el-button v-if="show3" type="primary" class="captcha-phone-button" @click="sendMessage()">重新获取验证码</el-button>
                                </el-form-item> -->
                            <el-form-item label="姓名" prop="displayName">
                                <el-input v-model="ruleForm.displayName"
                                        class="form_input"
                                        placeholder="请输入姓名"
                                        maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号：" prop="cardNumber">
                                <el-input v-model="ruleForm.cardNumber" class="form_input" placeholder="请输入用户名" maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item label="密码：" prop="password">
                                <el-input v-model="ruleForm.password" class="form_input" type="password" placeholder="请输入您的密码"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码：" prop="surePassword">
                                <el-input v-model="ruleForm.surePassword" class="form_input" type="password" placeholder="请输入您的密码"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号：" prop="phone">
                                <el-input v-model="ruleForm.phone" @blur="verificationMobile" class="form_input" placeholder="请输入您的手机号"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="form-tip-info-wrapper">
                            <div class="tip-1">请选择你所在的学校,如果没有此处<span @click="applySchool()" style="color:#3fa2ff;cursor: pointer;">申请学校</span></div>
                            <div class="tip-2">请填写正确手机号，手机号将作为登录账号。</div>
                            <div class="tip-3">请输入真实姓名，以便其他人快速了解您</div>
                            <div class="tip-4">请填写正确身份证号</div>
                            <div class="tip-5">密码可在个人中心更改</div>
                            <div class="tip-6">请确保两次密码一致</div>
                            <div class="tip-7">请输入手机号</div>
                        </div>
                    </div>
                    <div class="second-register-next-btn">
                        <el-button type="primary" :disabled="check" @click="register('registerForm')">立即注册</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <el-dialog :before-close="handleClose"
               title="单位申请"
               :visible.sync="dialogFormVisible"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="570px">
      <el-form 
               label-width="100px"
               class="clearfix">
        <el-form-item label="名称：">
          <el-input v-model="fromSchoolName"
                    style="width:70%;"
                    class="input-with-select"
                    placeholder="请输入名称"></el-input><span style="color:red;margin-left:10px">(全称)</span>
        </el-form-item>
        <el-form-item label="别名：">
          <el-input v-model="fromSchoolAlias"
                    style="width:70%;"
                    class="input-with-select"
                    placeholder="请输入别名"></el-input><span style="color:red;margin-left:10px">(历史名称或简称)</span>
        </el-form-item>
        <el-form-item label="所属省市：">
          <el-select v-model="fromSchoolProvince"
                     class="input-with-select"
                     filterable
                     placeholder="请选择省份"
                     @change="getCityList">
            <el-option v-for="item in optionsProvince"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="fromSchoolCity"
                     class="input-with-select"
                     placeholder="请选择市">
            <el-option v-for="item in cityList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：">
          <el-select v-model="fromSchoolType"
                     class="input-with-select"
                     filterable
                     placeholder="请选择类型">
            <el-option v-for="itemSchoolType in optionsSchoolType"
                       :key="itemSchoolType.value"
                       :label="itemSchoolType.label"
                       :value="itemSchoolType.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人姓名：">
          <el-input v-model="fromContactsName"
                    style="width:70%;"
                    class="input-with-select" 
                    placeholder="请输入申请人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" prop="phone" :rules="{ required: true, message: '联系方式不能为空' }">
          <el-input v-model="phone"
                    style="width:70%;"
                    class="input-with-select"
                    placeholder="请输入联系方式"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary"
                   @click="sure()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="message_dialog"
               top="10%"
               width="50%"
               class="clearfix change-dialog-head-wrapper"
               :show-close="false">
        <div style="font-size:22px;color:red;margin-left:20px;">已提交申请</div>
      <!-- <div style="font-size:22px;color:red;margin-left:20px;">申请结果将在1个工作日内以短信的方式通知到您。</div>
      <div style="font-size:22px;color:red;margin-left:20px;">客服联系方式：qq:528947274,邮箱：528947274@qq.com</div> -->
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="message_dialog=false">关闭</el-button>
      </div>
    </el-dialog>
</div>
</template>

<script>
import { urlAliyunOSSThumb } from "api/v1";
import {
    MU_UPATE_AUTH,
    MU_UPATE_SCHOOL
} from "store/index";
import CryptoJS from "crypto-js";
export default {
    data() {
        return {
            isRoleTab: '1',
            isShow: true,
            back: require('assets/images/bg.png'),
            ruleForm: {
                schoolId:"",
                cardNumber: '',
                password: '',
                phone: '',
                captcha: '',
                userType: 2,
                displayName:"",
                userName:"",
                surePassword: ''
            },
            rules: {
                schoolId:[{
                    required: true,
                    message: '学校不能为空',
                    trigger: 'blur'
                }],
                userName:[{
                    required: true,
                    message: '账号不能为空',
                    trigger: 'blur'
                }],
                displayName:[{
                    required: true,
                    message: '姓名不能为空',
                    trigger: 'blur'
                }],
                cardNumber: [{
                    required: true,
                    message: '身份证号不能为空',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: '密码不能为空',
                    trigger: 'blur'
                }],
                phone: [{
                    required: true,
                    message: '手机号不能为空',
                    trigger: 'blur'
                }],
                captcha: [{
                    required: true,
                    message: '验证码不能为空',
                    trigger: 'blur'
                }],
                surePassword: [{
                    required: true,
                    message: '密码不能为空',
                    trigger: 'blur'
                }],
            },
            show1: true,
            show2: false,
            show3: false,
            count: 60,
            isExitPhone: false,
            firstActive: true,
            secondActive: false,
            thirdActive: false,
            registerStepShow: [{
                    index: 1,
                    show: true
                },
                {
                    index: 2,
                    show: false
                },
                {
                    index: 3,
                    show: false
                }
            ],
            check: false,
            schoolList:[],
            // 申报学校字段
            dialogFormVisible:false,
            fromSchoolCode: "",
            fromSchoolName: "",
            fromSchoolAlias: "",
            fromSchoolProvince: "",
            fromSchoolCity: "",
            fromSchoolType: "",
            fromContactsName: "",
            fromSchoolUrl: "",
            fromContactsPost: "",
            fromContactInformation: "",
            phone: "",
            shortMessage: "",
            fromSalesman: "",
            fromSchoolLogoUrl: "",
            urlAliyunOSS: urlAliyunOSSThumb,
            optionsProvince: [],
            cityList: [],
            optionsSchoolType: [
                {
                value: "中职",
                label: "中职"
                },
                {
                value: "高职",
                label: "高职"
                },
                {
                value: "本科",
                label: "本科"
                },
                {
                value: "公司",
                label: "公司"
                },
                {
                value: "出版社",
                label: "出版社"
                },
                {
                value: "其他",
                label: "其他"
                }
            ],
            imageUrl: "",
            message_dialog:false
            //
        }
    },
    computed: {
        association: function () {
            return this.$store.state.association;
        },
    },
    created() {
        var that = this;
        that.$store.dispatch(MU_UPATE_SCHOOL, {
            id: window.location.href
        });
        this.getSchoolList();
    },
    methods: {
        /* 获取学校信息 */
        getSchoolList(){
            var that = this;
            this.$http.post("/api/XOrg/XLogin/getSchoolList", {
                SchoolType: "zwl",
            }).then(rst => {
                that.schoolList = rst.list;
                that.backOptions = rst.list;
            });
        },
        filterSchool: function(val) {
            var that = this;
            if (val) {
                // val存在
                that.schoolList = this.backOptions.filter(item => {
                    if (!!~item.name.indexOf(val) || !!~item.pinyin.indexOf(val)) {
                        return true;
                    }
                });
            } else {
                // val为空时，还原数组
                that.schoolList = this.backOptions;
            }
        },
        // 申请学校
        applySchool() {
            this.$http.post("/api/partner/PartnerApplication/getAllProvinceList", {
            }).then(rst => {
                this.optionsProvince = rst.province;
                this.dialogFormVisible = true;
            });
        },
        sure() {
            var that = this;
            this.$http.post("/api/common/login/applySchool", {
                SchoolId:this.fromSchoolId,
                SchoolCode:this.fromSchoolCode,
                SchoolName:this.fromSchoolName,
                SchoolAlias:this.fromSchoolAlias,
                SchoolProvince:this.fromSchoolProvince,
                SchoolCity:this.fromSchoolCity,
                SchoolType:this.fromSchoolType,
                ContactsName:this.fromContactsName,
                ContactsPost:this.fromContactsPost,
                ContactInformation:this.fromContactInformation,
                Salesman:this.fromSalesman,
                SchoolLogoUrl:this.fromSchoolLogoUrl,
                SchoolUrl:this.fromSchoolUrl,
                applyBy:"register",
                phone:this.phone,
                shortMessage:this.shortMessage,
                systemSource:"3"
            }).then(rst => {
                if (rst.code > 0) {
                    that.dialogFormVisible = false;
                    that.cancel();
                    that.message_dialog = true;
                    that.$message.success(rst.msg);
                    that.getSchoolList();
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
        cancel() {
            this.fromSchoolId = "";
            this.fromSchoolCode = "";
            this.fromSchoolName = "";
            this.fromSchoolAlias = "";
            this.fromSchoolProvince = "";
            this.fromSchoolCity = "";
            this.fromSchoolType = "";
            this.fromContactsName = "";
            this.fromSchoolUrl = "";
            this.fromContactsPost = "";
            this.fromContactInformation = "";
            this.phone = "";
            this.fromSalesman = "";
            this.shortMessage = "";
            this.dialogFormVisible = false;
        },
        handleClose() {
            this.cancel();
        },
        // 获取城市 省市联动
        getCityList(){
            this.$http.post("/api/partner/PartnerApplication/getCityList", {
                province:this.fromSchoolProvince
            }).then(rst => {
                if (rst.code > 0) {
                    this.cityList = rst.cityList;
                }
            });
        },
        // 下一步
        registerNext() {
            if (this.ruleForm.userType == 0) {
                this.$message.warning('请选择身份。');
                return false;
            } else {
                this.registerStepShow[0].show = false;
                this.registerStepShow[1].show = true;
                this.registerStepShow[2].show = false;
                this.firstActive = true;
                this.secondActive = true;
                this.thirdActive = false;
            }
        },
        // 返回上一步
        backToFirst() {
            this.registerStepShow[0].show = true;
            this.registerStepShow[1].show = false;
            this.registerStepShow[2].show = false;
            this.firstActive = true;
            this.secondActive = false;
            this.thirdActive = false;
        },
        // 下一步
        onSubmitNext() {
            this.registerStepShow[0].show = false;
            this.registerStepShow[1].show = false;
            this.registerStepShow[2].show = true;
            this.firstActive = true;
            this.secondActive = true;
            this.thirdActive = true;
        },
        verificationMobile() {
            var re = /^1\d{10}$/;
            if (re.test(this.ruleForm.phone)) {

            } else {
                this.$message.warning('手机号格式不正确');
                return false;
            }
        },
        //验证码
        sendMessage() {
            var once = true;
            let str_ = Date.parse(new Date()) / 1000;
            let str = this.encryption(str_);
            let str1 = CryptoJS.MD5(str_ + "").toString();
            var s1 = str1.substring(0, 7);
            var s2 = str1.substring(7);
            debugger;
            console.log(this.ruleForm.phone);
            str1 = s1 + "s" + s2;
            if (once) {
                var that = this;

                this.$http.post("/api/XOrg/XLogin/sendCode", {
                    verifyInfo: that.ruleForm.phone,
                    str: str,
                    str1: str1
                }).then(rst => {
                    if (rst.code > 0) {
                        this.$message.success(rst.msg);
                        this.verifyCode = rst.verifyCode;
                        const TIME_COUNT = 60;
                        if (!this.timer) {
                            this.count = TIME_COUNT;
                            this.show1 = false;
                            this.show2 = true;
                            this.show3 = false;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                    once = false;
                                } else {
                                    this.show1 = false;
                                    this.show2 = false;
                                    this.show3 = true;
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    once = true;
                                }
                            }, 1000);
                        }
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
            }
        },
        encryption: function (str) {
            let Base64 = require("js-base64").Base64;
            return Base64.encode(str);
        },
        roleTab(role) {
            this.isRoleTab = role;
        },
        //注册
        register(formName) {
            if(this.ruleForm.password !== this.ruleForm.surePassword){
               this.$message.warning('两次密码不一致');
               return false;
            }else {
                  this.$http.post("/api/XOrg/XLogin/register_new", {
                        userType: this.ruleForm.userType,
                        userName: this.ruleForm.userName,
                        displayName:this.ruleForm.displayName,
                        cardNumber: this.ruleForm.cardNumber,
                        phone: this.ruleForm.phone,
                        captcha: this.ruleForm.captcha,
                        password: this.ruleForm.password,
                        schoolId: this.ruleForm.schoolId
                    }).then(rst => {
                        if (rst.code > 0) {
                            this.onSubmitNext();
                            this.$message({
                                message: rst.msg,
                                type: 'success'
                            });
                            this.isShow = false;
                            this.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
                            this.goHome();
                        } else {
                            this.$message({
                                message: rst.msg,
                                type: 'warning'
                            });
                        }
                    });
            }
        },
        goHome() {
            this.$router.push({
                name: 'xIndex'
            })
        },
    },
    watch: {
        association: {
            handler(val) {
                document.title = val.associationName;
            },
            deep: true
        }
    }
}
</script>
